export const Row = ({ label, value }) => (
  <>
    <div className="col-span-1 font-bold">{label}</div>
    <div className="col-span-1">{value}</div>
  </>
);
